export const state = {
  files : [],
  file : {},
  mappingPerSheet: {},
  nextTab: {},
}

export const getters = {
  getMultipleFiles (state) {
    return state.files
  },
  getSingleFile (state) {
    return state.file
  },
  getMapping (state) {
    return state.mappingPerSheet
  },
  getNextTab (state) {
    return state.nextTab
  },
}

export const mutations = {
  SET_FILES (state, payload) {
    state.files = payload
  },
  SET_FILE (state, payload) {
    state.file = payload
  },
  SET_MAPPING (state, payload) {
    state.mappingPerSheet = payload
  },
  SET_NEXT_TAB (state, payload) {
    state.nextTab = payload
  }
}

export const actions = {
  setFiles({ commit }, data = []) {
    return commit('SET_FILES', data)
  },
  setFile({ commit }, data = {}) {
    return commit('SET_FILE', data)
  },
  setMapping({ commit }, data = {}) {
    return commit('SET_MAPPING', data)
  },
  setNextTab ({ commit }, data) {
    return commit('SET_NEXT_TAB', data)
  },
}
